export default "__VITE_ASSET__CS7d7Jn4__"